import { applyStylesToMobileExperience } from 'src/molecules/Shared/2024_Q1_people_magic/BaseAnimatedExperienceController/BaseAnimatedExperienceController.styles';
import styled, { css } from 'styled-components';

export const FromIdeaToLiveIdealMemberContainer = styled.div`
  width: 100%;
  display: grid;
  row-gap: 1rem;
  box-sizing: border-box;
  padding-right: 2rem;

  .ideal-member-input {
    box-shadow: 0px 0px 14px 0px #14192112;
  }

  ${applyStylesToMobileExperience(css`
    padding-right: 0;

    p,
    h1 {
      text-align: center;
    }
  `)}
`;

